<template>
  <div v-rect-loading="loading" class="interview-invitation">
    <div class="interview-header">
      <span class="title">{{ $t(`${i18nPrefix}.title`) }}</span>
    </div>
    <HmPersonalInfo></HmPersonalInfo>
    <div class="title">{{ $t(`${i18nPrefix}.title`) }}</div>
    <van-collapse v-model="activeNames">
      <van-collapse-item class="info" name="information" :title="$t(`${i18nPrefix}.label.information`)">
        <div v-for="(info, index) in interviewInfoList" class="info-item" :key="index">
          <div class="label">{{ info.label }}</div>
          <div class="value">{{ info.value }}</div>
        </div>
      </van-collapse-item>
    </van-collapse>
    <div class="content">
      <template v-if="isHmSelectInterviewTime">
        <div class="content-title">{{ $t(`${i18nPrefix}.label.selectTime`) }}</div>
        <InterviewDuration v-model="duration" ref="interviewDuration"/>
        <div class="time-zone">
          <span class="label">{{ $t(`${i18nPrefix}.label.timeZone`) }}</span>
          <InterviewSelect
            v-model="timeZone"
            class="time-zone-selector"
            valueKey="key"
            labelKey="value"
            :selectOptions="timeZoneList"
            @selectChange="handleTimezoneChange"
          />
        </div>
        <InterviewCalendar v-model="selectedDate" isMobile tableCellWidth="42px" class="interview-calendar" :selectedInterviewDateList="selectedDateList">
          <template #dayTableExtra>
            <InterviewSchedule
              class="interview-schedule"
              disabledTooltip
              :selectedDate="selectedDate"
              :hmScheduleList="hmScheduleList"
              :selectedDateTimeList="selectedDateTimeList"
              :durationMinutes="durationMinutes"
              @selectSchedule="handleSelectSchedule"
            />
          </template>
        </InterviewCalendar>
        <div class="title content-title">{{ $t(`${i18nPrefix}.label.interviewTime`) }}</div>
        <InterviewTimeRange
          v-for="(interviewDateTime, index) in selectedDateTimeList"
          ref="interviewDateTimeRange"
          :key="interviewDateTime.vid"
          :index="index"
          :durationMinutes="durationMinutes"
          :errorMessage="interviewDateTime.duplicate ? $t(`${i18nPrefix}.message.duplicateDateTime`) : ''"
          :interviewDateTime="interviewDateTime"
          @deleteTime="handleDeleteTime(index)"
          @change="handleTimeRangeChange(index, $event)"
          @endTimeClick="handleEndTimeClick"
        />
      </template>
      <template v-else-if="isInterviewScheduled">
        <div class="content-title">{{ $t(`${i18nPrefix}.label.interviewTime`) }}</div>
        <div class="interview-time">
          <div class="interview-time-item is-selected">
            <div class="date">{{ formatDate(interviewedTime.startDate) }}</div>
            <div class="time-range">{{ formatDateTime(interviewedTime.startDate, interviewedTime.startTime, interviewedTime.endTime) }}</div>
          </div>
        </div>
      </template>
      <div v-else-if="isInterviewCanceled" class="canceled">{{ $t(`${i18nPrefix}.label.canceled`) }}</div>
      <template v-if="!isHmSelectInterviewTime && (isCandidateSelectInterviewTime || isSuggestNewTime)">
        <template v-if="interviewedTime">
          <div class="content-title">{{ $t(`${i18nPrefix}.label.interviewTime`) }}</div>
          <div class="interview-time">
            <div class="interview-time-item is-selected">
              <div class="date">{{ formatDate(interviewedTime.startDate) }}</div>
              <div class="time-range">{{ formatDateTime(interviewedTime.startDate, interviewedTime.startTime, interviewedTime.endTime) }}</div>
            </div>
          </div>
        </template>
        <template v-if="showAvailableInterviewTime">
          <div class="content-title">{{ interviewTimeLabel }}</div>
          <div class="interview-time">
            <div v-for="(time, index) in availableInterviewTimeList" class="interview-time-item" :key="index">
              <div class="date">{{ formatDate(time.startDate) }}</div>
              <div class="time-range">{{ formatDateTime(time.startDate, time.startTime, time.endTime) }}</div>
            </div>
          </div>
        </template>
      </template>
      <div v-if="!hiddenBtn" class="btn-group">
        <el-button class="btn-item common-btn cancel-btn" @click="handleCancelInterview">{{ $t('common.btn.cancel') }}</el-button>
        <el-button v-if="isHmSelectInterviewTime" class="btn-item confirm-btn" type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button v-if="showScheduleBtn" class="btn-item common-btn confirm-btn" @click="handleReschedule">{{ $t(`${i18nPrefix}.btn.${isHmSuggestNewTime ? 'suggestNewTime' : 'reschedule'}`) }}</el-button>
      </div>
    </div>
    <MobileCommonDialog
      class="cancel-dialog"
      :show.sync="dialog.show"
      :loading="dialog.loading"
      @save="confirmCancelInterview"
    >
      <template #title>
        <div class="dialog-title">
          {{ $t(`${i18nPrefix}.label.cancelInterview`) }}
        </div>
      </template>
    </MobileCommonDialog>
  </div>
</template>

<script>
import MobileCommonDialog from '@/components/dialog/mobileCommonDialog.vue'
import InterviewDuration from '@/components/interview/mobile/interviewDuration.vue'
import InterviewSchedule from '@/components/interview/interviewSchedule.vue'
import InterviewCalendar from '@/components/interview/interviewCalendar.vue'
import InterviewTimeRange from '@/components/interview/mobile/interviewTimeRange.vue'
import interviewInvitationMixin from '@/views/hm/common/interviewInvitationMixin'
import InterviewSelect from '@/components/interview/mobile/interviewSelect.vue'
import HmPersonalInfo from '@/views/hm/mobile/components/hmPersonalInfo.vue'

export default {
  components: {
    HmPersonalInfo,
    MobileCommonDialog,
    InterviewSelect,
    InterviewTimeRange,
    InterviewCalendar,
    InterviewSchedule,
    InterviewDuration
  },
  mixins: [interviewInvitationMixin],
  data () {
    return {
      activeNames: []
    }
  },
  computed: {},
  created () {
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.interview-invitation {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;

  .interview-header {
    background-color: #0b0d1a;
    display: flex;
    justify-content: center;
    padding: 0 10%;

    .title {
      text-align: center;
      color: #FFFFFF;
      font-size: 18px;
      margin: 40px 0;
      padding: 0;
    }
  }

  .title {
    padding: 18px 0 20px 20px;
    font-weight: 600;
    font-size: 20px;
    color: #000;
    line-height: 28px;
  }

  .van-collapse {
    .info {
      .info-title {
        font-weight: 500;
        font-size: 16px;
        color: #000;
        line-height: 22px;
      }

      .info-item {
        margin-top: 8px;

        .label {
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          color: #999;
        }

        .value {
          margin-top: 4px;
          font-size: 14px;
          color: #000;
          line-height: 20px;
        }
      }

      ::v-deep {
        .van-cell {
          padding-left: 20px;
        }

        .van-collapse-item__content {
          padding: 0 20px 18px;
        }
      }
    }

    &::after {
      border-color: #e5e5e5;
    }

    ::v-deep {
      .van-cell__title {
        font-weight: 500;
        font-size: 16px;
        color: #000;
        line-height: initial;
      }
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 30px;

    .content-title {
      font-weight: 500;
      font-size: 16px;
      color: #000;
      line-height: 22px;
      padding-left: 0;
    }

    .interview-duration {
      margin-top: 16px;

      ::v-deep {
        .van-field__control {
          color: #000;
        }
      }
    }

    .time-zone {
      margin-top: 16px;
      display: flex;
      align-items: center;

      .label {
        font-size: 14px;
        color: #000;
        line-height: 20px;
        width: 96px;
      }

      .time-zone-selector {
        flex: 1;

        ::v-deep {
          .van-field__control {
            color: #000;
          }
        }
      }
    }

    .interview-calendar {
      margin-top: 16px;
    }

    .calendar-content {
      margin-top: 16px;

      &.is-mobile {
        ::v-deep {
          .van-collapse-item {
            .van-collapse-item__wrapper {
              margin-right: -4px;
            }
          }
        }
      }
    }

    .interview-schedule {
      width: calc(100% + 8px);
      padding-right: 4px;

      ::v-deep {
        .header {
          margin-right: 4px;
        }

        .content {
          margin-top: 10px;
          max-height: 132px;

          .schedule-table {
            grid-template-columns: repeat(2, 1fr);
            gap: 6px 10px;
            margin-right: 4px;

            .schedule-item {
              width: initial;
              height: 40px;

              &:hover {
                background-color: #fff;
              }

              &.is-selected {
                font-weight: 500;
                background-color: rgba(0, 150, 204, 0.1);
              }
            }
          }
        }
      }
    }

    .interview-time-range {
      & + .interview-time-range {
        margin-top: 10px;
      }
    }

    .suggest-new-time,
    .canceled {
      font-size: 14px;
      line-height: 20px;
      color: #666;
      text-align: center;
    }

    .canceled {
      padding-top: 50px;
    }

    .btn-group {
      display: flex;
      margin-top: auto;
      padding-top: 48px;

      .common-btn {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #0096cc;
        color: #0096cc;

        &:hover {
          background: rgba(0, 150, 204, 0.1);
        }
      }

      .btn-item {
        flex: 1;
      }

      .confirm-btn {
        display: block;
        width: 100%;
        height: 48px;
      }
    }

    .interview-time {
      margin: 20px 0;
      min-height: 100px;

      .interview-time-item {
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 2px;
        border: 1px solid rgba(0, 150, 204, 0.3);
        color: #0096cc;
        box-sizing: border-box;
        cursor: pointer;

        &.is-selected {
          background: rgba(0, 150, 204, 0.1);
          border-radius: 4px;
          border-width: 0;

          .date, .time-range {
            font-weight: 500;
          }
        }

        & + .interview-time-item {
          margin-top: 10px;
        }

        .date, .time-range {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
  }

  .cancel-dialog {
    ::v-deep {
      .dialog-content {
        .container-body {
          min-height: initial;
        }
      }
    }
  }
}
</style>
